import requests from '../httpService';

const TokenServices = {
    saveToken(body) {
        return requests.post('/saveFcmToken', body)
    }
}

export default TokenServices;